export const RouteConfig = {
  login: {
    name: "登录",
    path: "/login"
  },
  home: {
    name: "首页",
    path: "/"
  },
  sceneList: {
    name: "场景管理",
    path: "/scene/list"
  },
  sceneDetail: {
    name: "场景详情",
    path: "/scene/detail/:id"
  },
  userManagement: {
    name: "用户管理",
    path: "/user/list"
  },
  systemConfigPage: {
    name: "系统配置",
    path: "/system/config"
  },
  modulePage: {
    name: "模块管理",
    path: "/module/list"
  },
  taskPage: {
    name: "任务管理",
    path: "/task/list"
  },
}